export const production = true;
 
// DEV
const API_URL_DEV = 'https://api.dev.teeread.com/api';

// PRODUCTION
const API_URL_PRODUCTION = 'https://api.teeread.com/api';

export const URL_BACKEND = production ? API_URL_PRODUCTION : API_URL_DEV;
